module.exports = __webpack_public_path__ + "img/Forestier_01_FM.b6f10761.jpg";